import { GraphQLEnumType } from 'graphql'

export type ATOAttackIntervalType =
  | 'LastThirtyDays'
  | 'LastSevenDays'
  | 'LastTwentyFourHours'
  | 'LastHour'
  | 'LastFiveMinutes'

export const ATOAttackInterval = new GraphQLEnumType({
  name: 'ATOAttackInterval',
  description: 'The time interval for filtering ATO attack data',
  values: {
    LastThirtyDays: {},
    LastSevenDays: {},
    LastTwentyFourHours: {},
    LastHour: {},
    LastFiveMinutes: {}
  }
})
